 
 
 
 
 
 
define(['../selector'], function(selector) {
    'use strict';
    return function(json) {
        return selector(json, 'viewpResp.trafficState.@trafficModelId') || -1;
    };
});



// WEBPACK FOOTER //
// ./model/traffic/trafficModelId.js